<template>
  <div>
    <Breadcrumbs title="Dashboard" />
    <div class="container-fluid dashboard-2">
      <div class="row starter-main">
        <div class="col-12">
          <goalView :app="estadisticas.app" :cargando="cargando" />
        </div>
      </div>

      <resumenCards
        :total-productos="estadisticas.totalProductos"
        :imagenesUltimos7Dias="estadisticas.imagenesUltimos7Dias"
      />

     
    </div>
  </div>
</template>

<script>
import { apiFetch, BASE_URL } from "@/services/api";
import goalView from "@/components/dashboard/goalView.vue";
import resumenCards from "@/components/dashboard/resumenCards.vue";

const estadisticasVacias = () => ({
  imagenesUltimos7Dias: 0,
  totalProductos: 0,
  productosCompletos: 0,
  imagenesPorMes: [],
  app: null,
});

export default {
  name: "IndexDashboard",
  components: { goalView, resumenCards },
  data() {
    return {
      estadisticas: estadisticasVacias(),
      cargando: true,
      chartOptions: {
        chart: {
          height: 280,
          type: "area",
          toolbar: { show: false },
        },
        stroke: { width: 2, curve: "smooth" },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.4,
            opacityTo: 0.1,
          },
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: { text: "Imágenes" },
        },
        colors: ["#5c61f2"],
        tooltip: {
          x: { format: "MMM yyyy" },
        },
        dataLabels: { enabled: false },
      },
    };
  },
  computed: {
    chartSeries() {
      return [
        {
          name: "Imágenes",
          data: this.estadisticas.imagenesPorMes.map((m) => m.total),
        },
      ];
    },
  },
  async mounted() {
    await this.cargarEstadisticas();
  },
  methods: {
    async cargarEstadisticas() {
      this.cargando = true;
      try {
        const res = await apiFetch(`${BASE_URL}/api/dashboard/estadisticas`);
        if (!res.ok) throw new Error("Error al cargar estadísticas");
        const data = await res.json();
        this.estadisticas = { ...estadisticasVacias(), ...data };

        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {
            ...this.chartOptions.xaxis,
            categories: data.imagenesPorMes.map((m) => this.formatearMes(m.mes)),
          },
        };
      } catch (e) {
        console.error("Error cargando estadísticas:", e);
        this.estadisticas = estadisticasVacias();
      } finally {
        this.cargando = false;
      }
    },
    formatearMes(anioMes) {
      if (!anioMes) return "";
      const [anio, mes] = String(anioMes).split("-");
      const meses = [
        "Ene", "Feb", "Mar", "Abr", "May", "Jun",
        "Jul", "Ago", "Sep", "Oct", "Nov", "Dic",
      ];
      const idx = parseInt(mes, 10) - 1;
      return `${meses[idx] || mes} ${anio}`;
    },
  },
};
</script>